if (!global.Intl) {
    require('intl');

    require('intl/locale-data/jsonp/en.js');
    require('intl/locale-data/jsonp/ru.js');
}



// WEBPACK FOOTER //
// ./js/shared/polyfills/intl.js